class resultSlider{
  
    options       = {};
    slider        = null;
    dom           = null;
    tickerSpeed   = 2; 
    isPaused      = false;
    sliderdom     = null;

  constructor(ele, params = null, speed = 1.3, direction = 'rtl'){
    
        this.setSliderDom(ele);

        if(this.sliderdom){
          
          if(params != null)                      
            this.options  = params;
          else
            this.setDefaults();
  
          this.setSpeed(speed);
          this.setDirection(direction);        
          this.startSlider()
            
          //this.setEventListeners();
  
          this.update();  
          
        }

        
    }

    setSpeed = (speed)=>{

      this.tickerSpeed = speed;

    }

    setDirection = (direction)=>{

      if(direction=='ltr'){
        this.tickerSpeed = -1 * this.tickerSpeed;
      }

    }

    setSliderDom = (ele)=>{
      this.sliderdom      = document.querySelector(ele);
    }

    setEventListeners = ()=>{
      
      this.sliderdom.addEventListener('mouseenter',this.pause , false);
      this.sliderdom.addEventListener('focusin', this.pause, false);
      this.sliderdom.addEventListener('mouseleave', this.play, false);
      this.sliderdom.addEventListener('focusout', this.play, false);
      console.log(this.sliderdom);
    }

    setDefaults= ()=>{

      this.options  = {
                      autoPlay: false,
                      prevNextButtons: false,
                      pageDots: false,
                      draggable: true,
                      wrapAround: true,
                      selectedAttraction: 0.015,
                      friction: 0.25
                    };

    }

    startSlider = () =>{
      
      this.slider   = new Flickity(this.sliderdom, this.options);

      this.slider.x = 0;     

      this.slider.on('dragStart', () => {
        this.isPaused = true;
      });

    }

    update = () => {
      
      let isPaused  = this.sliderisPaused;      
      let slider    = this.slider;
    
      if (isPaused) return;

      if (slider.slides) {
   
        slider.x = (slider.x - this.tickerSpeed) % slider.slideableWidth;        
        
        slider.selectedIndex = slider.dragEndRestingSelect();
        slider.updateSelectedSlide();
        slider.settle(slider.x);

      }

      window.requestAnimationFrame(this.update);
  }

  pause = () => {
    this.sliderisPaused = true;
  }

  play = () => {

    if (this.sliderisPaused) {
      this.sliderisPaused = false;
      window.requestAnimationFrame(this.update);
    }

  }   


} 